import { css } from 'linaria';
import { breakpointSmallDesktop } from 'common/constants';
import { breakpointLargeTablet } from 'common/constants';
import { breakpointMediumTablet } from 'common/constants';
import { breakpointSmallTablet } from 'common/constants';
import { breakpointTinyTablet } from 'common/constants';
import { breakpointLargeHandset } from 'common/constants';
import { breakpointSmallHandset } from 'common/constants';
import { breakpointMediumHandset } from 'common/constants';

// !! Caution
// Changes to cardStyles will change ALL cards across the app (eventually).
// The goal of these styles is to provide a baseline of styles which should/
// be overridden for specific card types
export const cardStyles = "c18o9ext";

require("./card-base.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./card-base.js");